import { useCallback, useState } from "react";

import { EditorSyncFiles } from "../EditorSync";
import { CueSheetItem } from "../types/editor";
import EditorPlayerVideo from "./EditorPlayerVideo";
import { EditorPlayerProgress } from "./types";

export const EditorPlayerSet = ({
  item,
  progress,
  files,
}: {
  item: CueSheetItem;
  progress?: (progress: EditorPlayerProgress) => unknown;
  files: EditorSyncFiles;
}) => {
  const [mode, _mode] = useState<"action" | "loop">("action");

  const oap = useCallback(
    (p: EditorPlayerProgress) => {
      if (mode === "action") {
        progress?.(p);
      }
    },
    [mode]
  );
  const olp = useCallback(
    (p: EditorPlayerProgress) => {
      if (mode === "loop") {
        progress?.(p);
      }
    },
    [mode]
  );
  const oae = useCallback(() => {
    _mode("loop");
  }, [mode]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          zIndex: mode !== "action" ? -10 : 10,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <EditorPlayerVideo
          src={item.set?.action || ""}
          loop={false}
          playing={true}
          paused={false}
          muted={true}
          progress={oap}
          ended={oae}
          files={files}
        />
      </div>
      <div
        style={{
          zIndex: 2,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <EditorPlayerVideo
          src={item.set?.loop || ""}
          loop={true}
          playing={mode === "loop"}
          paused={false}
          muted={true}
          progress={olp}
          files={files}
        />
      </div>
    </div>
  );
};

export default EditorPlayerSet;
